import { useContext } from "react"

import VulnerabilityContext, { VulnerabilityContextType } from "./VulnerabilityContext"

export const useVulnerabilityContext = (): VulnerabilityContextType => {
  const ctx = useContext(VulnerabilityContext);

  if (!ctx) {
    throw new Error('useVulnerabilityContext must be called with a VulnerabilityContextProvider');
  }

  return ctx;
};
